import { type ComplianceState } from "./state";

export const initialState: ComplianceState = {
  customers: { items: [], page: 1, pageSize: 25, totalItems: 0 },
  isSearching: false,
  searchError: "",
  caseRequestId: null,
  caseData: null,
  isCasePending: false,
  caseError: "",
  revealedNationalId: null,
  revealedAt: null,
  isRevealing: false,
  revealError: "",
  isExporting: false,
  isReplacingCapture: false,
  isSavingCustody: false,
  isSavingState: false,
  isSavingAddress: false,
  geoCatalog: [],
};
